export const MENU_SCREEN = "/menu"
